import {
  FISCAL_INDICATOR_CUTOFFS,
  INPC_BY_MONTH,
  UDI_BY_DATE,
} from "./fiscal-indicators.generated";

export const FISCAL_INDICATOR_SOURCES = {
  inpc: "https://www.inegi.org.mx/Programas/inpc/2018/default.html",
  udi: "https://www.banxico.org.mx/SieInternet/consultarDirectorioInternetAction.do?accion=consultarCuadro&idCuadro=CP150",
} as const;

function positiveOverride(value: number | undefined): number | undefined {
  return value !== undefined && Number.isFinite(value) && value > 0
    ? value
    : undefined;
}

export function monthKey(date: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    throw new Error("La fecha debe tener formato AAAA-MM-DD.");
  }
  return date.slice(0, 7);
}

export function previousMonthKey(date: string): string {
  const [year, month] = monthKey(date).split("-").map(Number);
  const previous = new Date(Date.UTC(year, month - 2, 1));
  return `${previous.getUTCFullYear()}-${String(previous.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function udiForDate(date: string, override?: number): number {
  const manual = positiveOverride(override);
  if (manual !== undefined) return manual;
  const value = UDI_BY_DATE[date];
  if (value === undefined) {
    throw new Error(
      `No hay UDI automática para ${date}. Captúrala en el modo avanzado.`,
    );
  }
  return value;
}

export function inpcForMonth(month: string, override?: number): number {
  const manual = positiveOverride(override);
  if (manual !== undefined) return manual;
  const value = INPC_BY_MONTH[month];
  if (value === undefined) {
    throw new Error(
      `No hay INPC automático para ${month}. Captúralo en el modo avanzado.`,
    );
  }
  return value;
}

export { FISCAL_INDICATOR_CUTOFFS };
